import { createFileRoute } from "@tanstack/react-router";
import { legacyPostRoute } from "@/features/legacy-operations";

export const Route = createFileRoute("/api/kits/fanout/gmail/claim")({
    ...legacyPostRoute,
});
